module.exports = __webpack_public_path__ + "assets/img/girl.273ba282.png";